/* IP - SPEED OPTIMIZATION - TRUSTPILOT: one bootstrap, visible widgets only. */
(() => {
  if (customElements.get('coco-trustpilot')) return;
  let bootstrap;
  function loadBootstrap() {
    if (window.Trustpilot?.loadFromElement) return Promise.resolve();
    if (bootstrap) return bootstrap;
    bootstrap = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
      script.async = true;
      script.onload = () => window.Trustpilot?.loadFromElement ? resolve() : reject(new Error('Trustpilot unavailable'));
      script.onerror = () => reject(new Error('Trustpilot unavailable'));
      document.head.append(script);
    });
    return bootstrap;
  }
  class CocoTrustpilot extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.drawer = this.closest('cart-drawer');
      if (this.drawer) {
        this.drawerObserver = new MutationObserver(() => this.checkVisibility());
        this.drawerObserver.observe(this.drawer, { attributes: true, attributeFilter: ['class'] });
      }
      this.visibility = new IntersectionObserver(entries => {
        this.inView = entries.some(entry => entry.isIntersecting);
        this.checkVisibility();
      });
      this.visibility.observe(this);
    }
    checkVisibility() {
      if (!this.inView || (this.drawer && !this.drawer.classList.contains('active')) || this.started) return;
      this.started = true;
      this.visibility.disconnect();
      this.drawerObserver?.disconnect();
      loadBootstrap().then(() => {
        if (!this.isConnected) { this.started = false; return; }
        const widget = this.querySelector('[data-tp-widget]');
        // The official bootstrap creates the iframe synchronously. Keep the custom
        // fallback until its document loads; a blocked request leaves the link usable.
        window.Trustpilot.loadFromElement(widget, true);
        this.frame = widget.querySelector('iframe');
        this.onLoaded = () => {
          if (!this.isConnected) return;
          this.dataset.ready = 'true';
          widget.removeAttribute('inert');
          widget.removeAttribute('aria-hidden');
          this.querySelector('[data-tp-placeholder]').hidden = true;
        };
        this.frame?.addEventListener('load', this.onLoaded, { once: true });
      }).catch(() => { this.dataset.failed = 'true'; });
    }
    disconnectedCallback() {
      this.visibility?.disconnect();
      this.drawerObserver?.disconnect();
      this.frame?.removeEventListener('load', this.onLoaded);
      this.started = false;
    }
  }
  customElements.define('coco-trustpilot', CocoTrustpilot);
})();
